<div id="body">
  <img src="./assets/logo-login.svg" id="logo">
  <h1>Ops...</h1>
  <p>Página não encontrada</p>
</div>